import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { clearLegacyVisitorNoticeLocalStorage } from './utils/visitorNotice'
import {
  Button,
  Cell,
  CellGroup,
  Field,
  Form,
  NavBar,
  Popup,
  Picker,
  DatePicker,
  TimePicker,
  Loading,
  Empty,
  Icon,
  Divider,
  SubmitBar,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup
} from 'vant'
import 'vant/lib/index.css'

// 旧版用 localStorage 长期保留「已读」，会导致再次进首页时仍直接进登记；启动时清一次，改由 session 控制
clearLegacyVisitorNoticeLocalStorage()

const app = createApp(App)

// 注册Vant组件（Toast和Dialog是函数式组件，不需要在这里注册）
const components = [
  Button,
  Cell,
  CellGroup,
  Field,
  Form,
  NavBar,
  Popup,
  Picker,
  DatePicker,
  TimePicker,
  Loading,
  Empty,
  Icon,
  Divider,
  SubmitBar,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup
]

components.forEach(component => {
  app.use(component)
})

app.use(router)
app.mount('#app')
